import React from 'react';
import { useTranslation } from 'react-i18next';
import { FullscreenOutlined } from '@ant-design/icons';

import { BlockWrapper, IconButton, Spin, Chart as NpChart, NoData } from 'components';

import useChartOptions from './hooks/useChartOptions';

import { IChartProps } from './Chart.types';

import './Chart.styles.scss';

const Chart = ({ data, loading, title, enableExpend, width, height, onExpand, ...props }: IChartProps) => {
  const { t } = useTranslation();

  const options = useChartOptions(data);

  const noData = !data || !data?.series?.length || !data?.dates?.length;

  return (
    <BlockWrapper {...props}>
      <div className="np-profit-chart__header">
        <BlockWrapper.Title className="np-profit-chart__title">{t(title)}</BlockWrapper.Title>

        {enableExpend && <IconButton icon={<FullscreenOutlined />} tooltip="tooltip.expand" onClick={onExpand} />}
      </div>

      {loading && <Spin />}

      {!loading && noData && <NoData />}

      {!loading && !noData && <NpChart width={width} height={height} option={options} />}
    </BlockWrapper>
  );
};

export default Chart;
